import React from "react";
import MetaTags from "react-meta-tags";
import Subscribe from "../../component/Subscribe";
import "../../common/SCSS/newsletterStyle.css";

function Newsletter_40() {
  return (
    <>
      <section
        className="about-banner-section"
        style={{ padding: "150px 0 62px" }}
      >
        <div className="about-circle">
          <div className="about-circle-1"></div>
          <div className="about-circle-2"></div>
          <div className="about-circle-3"></div>
          <div className="about-circle-4"></div>
          <div className="about-circle-5"></div>
        </div>
        <div className="about-banner-container">
          <div className="about-content">
            <h1 className="about-title" style={{ paddingTop: "25px" }}>
              SustainabilityConnect
            </h1>
            <p
              className="about-description"
              style={{ fontSize: "25px", marginTop: "18px", marginBottom: "0" }}
            >
              Newsletter January 2026
            </p>
          </div>
        </div>
        <div className="about-elements">
          <div className="about-element-1"></div>
          <div className="about-element-2"></div>
          <div className="about-element-3"></div>
          <div className="about-element-4"></div>
          <div className="about-element-5"></div>
        </div>
      </section>
      <div className="newsletter-container">
        <MetaTags>
          <title>
            FCA Proposes Regulatory Framework for ESG Ratings Providers to
            Enhance Market Integrity.
          </title>
          <meta
            name="description"
            content="The UK’s Financial Conduct Authority (FCA) has proposed a new regulatory framework to bring ESG ratings providers under formal supervision, aiming to enhance confidence, consistency and transparency in sustainability-related assessments."
          />
          <meta
            property="og:title"
            content="UpdaptCSR | Sustainability Platform"
          />
        </MetaTags>

        <div
          className="Newsletter-title1"
          style={{ paddingTop: "56px", fontSize: "32px" }}
        >
          FCA Proposes Regulatory Framework for ESG Ratings Providers to Enhance
          Market Integrity.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/Jan_2026_1.webp")}
            alt="FCA Proposes Regulatory Framework for ESG Ratings Providers to Enhance Market Integrity."
            loading="lazy"
          />
        </figure>
        <p>
          The UK’s Financial Conduct Authority (FCA) has proposed a new
          regulatory framework to bring ESG ratings providers under formal
          supervision, aiming to enhance confidence, consistency and
          transparency in sustainability-related assessments. The proposals
          follow draft legislation that would classify ESG ratings as a
          regulated activity, responding to strong market support for oversight
          amid the growing influence of ESG scores on capital allocation and
          risk management decisions.
        </p>
        <p>
          Global demand for ESG data and ratings continues to accelerate, with
          market estimates valuing annual spending at over USD 2 billion.
          Despite this growth, users have raised persistent concerns around the
          lack of clarity in methodologies, data sources and rating objectives,
          as well as insufficient governance and internal controls. The FCA
          estimates that introducing regulation could generate net benefits of
          approximately GBP 500 million over ten years by reducing
          inefficiencies and improving decision-useful information.
        </p>
        <p>
          Under the proposals, ESG ratings providers would be required to
          disclose key methodological details, strengthen governance frameworks
          and manage conflicts of interest more effectively. Additional measures
          include formal engagement and complaints processes, allowing rated
          entities to challenge factual inaccuracies. The FCA expects
          authorisation requirements to come into effect from mid-2028, subject
          to consultation outcomes.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The FCA’s proposed oversight of ESG ratings providers is likely to
            accelerate structural change across the sustainability data
            ecosystem. By formalising governance, disclosure and
            conflict-management standards, the regime will raise barriers to
            entry while rewarding methodological rigour and data credibility.
            Over time, this may drive consolidation, reduce score divergence and
            improve investor confidence, positioning ESG ratings as a more
            decision-useful input rather than a broad signalling tool.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          New York Introduces Comprehensive Mandatory GHG Reporting Regime for
          High-Emitting Sectors.
        </div>
        <div className="Newsletter-picture">
          <figure style={{ marginTop: "25px" }}>
            <img
              className="picture"
              src={require("../../../../../assets/Newsletter/Jan_2026_2.webp")}
              alt="New York Introduces Comprehensive Mandatory GHG Reporting Regime for High-Emitting Sectors. "
              loading="lazy"
            />
          </figure>
        </div>
        <p>
          New York has finalized a Mandatory Greenhouse Gas Reporting Program
          aimed at creating a comprehensive, verifiable emissions database to
          support statewide climate policy. The regulation operationalizes the
          state’s climate law by strengthening transparency, improving emissions
          tracking, and informing future regulatory and market-based
          interventions across high-emitting sectors.
        </p>
        <p>
          Beginning with emissions generated in 2026, covered entities must
          quantify, document, and retain greenhouse gas emissions data using
          prescribed calculation methodologies. The first emissions report is
          due by June 1, 2027, with annual submissions required thereafter.
          Obligated parties include facility operators emitting 10,000 metric
          tons or more of CO₂ equivalent annually, fuel suppliers, electricity
          importers, waste transporters, fertilizer and lime suppliers, and
          certain waste management activities. Robust recordkeeping and internal
          controls are mandatory to ensure data accuracy and audit readiness.
        </p>
        <p>
          Entities classified as Large Emission Sources face enhanced
          obligations, including independent third-party verification by
          accredited verifiers. These entities must submit verification
          statements by December 1, 2027, followed by a recurring verification
          cycle. The program is designed to strengthen regulatory oversight,
          improve emissions integrity, and enable data-driven progress toward
          long-term decarbonization targets.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The regulation enables companies to gain clearer visibility into
            their emissions profiles, strengthen governance, and align
            operations with evolving climate expectations from regulators,
            investors, and customers. To prepare, companies should establish
            robust emissions accounting systems, enhance data controls, engage
            qualified verification partners early, and integrate emissions
            management into enterprise risk and compliance frameworks.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Canada Sets 2026 Timeline for Science-Based Sustainable Investment
          Guidelines.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/Jan_2026_3.webp")}
            alt="Canada Sets 2026 Timeline for Science-Based Sustainable Investment Guidelines."
            loading="lazy"
          />
        </figure>
        <p>
          Canada has formally committed to launching a made-in-Canada
          sustainable investment taxonomy by the end of 2026. This voluntary
          framework will provide science-based criteria to classify economic
          activities and investments as “green” or “transition,” helping
          investors, financial institutions, and corporations identify
          sustainability alignment and reduce greenwashing risks. The Canadian
          Climate Institute, in partnership with Business Future Pathways, will
          lead the development and convene an independent Taxonomy Council to
          review and approve guidelines. This governance structure will include
          experts from finance, climate science, academia, civil society and
          Indigenous communities.
        </p>
        <p>
          The taxonomy’s first phase will define eligibility criteria for
          investment activities in three priority sectors by late 2026, with
          three more sectors by fall 2027. Priority selection will be based on
          potential to drive emissions reduction and enhance low-carbon
          competitiveness across the economy. The taxonomy is designed to align
          with global best practices and be broadly compatible with
          international frameworks, while supporting credibility for green and
          transition bonds, sustainable finance instruments, and corporate
          transition plans.
        </p>
        <p>
          Beyond market classification, these guidelines are part of Canada’s
          broader effort under Budget 2025 to mobilize private capital toward
          net-zero goals, improve climate-related disclosures, and strengthen
          sustainable finance infrastructure. Clear definitions are expected to
          foster transparency, support capital flows to clean technologies and
          decarbonization projects, and improve confidence among global and
          domestic investors.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The introduction of a national sustainable investment taxonomy is
            critical for industry as it brings long-needed clarity, consistency
            and credibility to sustainable finance. By clearly defining what
            qualifies as green or transition activities, it reduces uncertainty,
            limits greenwashing risk, and improves comparability across
            financial products. This clarity enables investors to allocate
            capital with confidence, supports credible transition strategies for
            high-emitting sectors, and accelerates capital flows toward net-zero
            aligned projects.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          European Union Introduces Harmonised Policy Framework to Strengthen
          Plastics Recycling Markets.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/Jan_2026_4.webp")}
            alt="European Union Introduces Harmonised Policy Framework to Strengthen Plastics Recycling Markets."
            loading="lazy"
          />
        </figure>
        <p>
          The European Union has introduced a coordinated set of regulatory
          measures aimed at restoring confidence and investment in the plastics
          recycling sector, which has faced sustained pressure over the past
          three years. High energy prices, weak demand for recycled polymers,
          and competition from cheaper virgin plastics have led to declining
          margins and stalled capacity expansion across several Member States.
          Recycling growth has slowed markedly, despite EU policy targets
          calling for higher recycled content and reduced dependence on
          fossil-based materials.
        </p>
        <p>
          At the core of the initiative is the harmonisation of “end-of-waste”
          criteria for recycled plastics across the EU. These rules are designed
          to clarify when plastic waste, after processing, legally becomes a
          secondary raw material that can be freely traded within the single
          market. By reducing regulatory fragmentation and uncertainty, the
          Commission aims to improve market transparency, lower compliance
          costs, and create a level playing field for recyclers operating across
          borders. In parallel, updated methodologies for calculating recycled
          content in plastic products, particularly beverage bottles, are
          intended to ensure consistency, credibility, and investor confidence.
        </p>
        <p>
          Additional measures include the development of distinct customs codes
          for virgin and recycled plastics, improved market monitoring, and the
          potential use of trade instruments if market distortions persist.
          Collectively, these actions are positioned as a transitional step
          toward a broader Circular Economy Act expected in 2026.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The harmonised EU framework strengthens the circular economy by
            creating clear conditions for when recycled plastics re-enter the
            market as secondary raw materials. By improving traceability,
            consistency, and credibility of recycled content, the policy
            supports material circulation, reduces reliance on virgin resources,
            and enables scalable circular business models aligned with long-term
            climate and resource efficiency goals.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Global Asset Owner Survey Signals a Structural Shift Toward
          Performance-Led Sustainable Investing.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/Jan_2026_5.webp")}
            alt="Global Asset Owner Survey Signals a Structural Shift Toward Performance-Led Sustainable Investing."
            loading="lazy"
          />
        </figure>

        <p>
          A recent global survey by a leading index and analytics provider
          company highlights a clear shift in how asset owners approach
          sustainability. Covering more than 400 asset owners across over 20
          markets, the survey shows that sustainability considerations are now
          firmly embedded in mainstream investment processes. Around
          three-quarters of respondents report using sustainable investment
          approaches, while four in five integrate climate or sustainability
          factors, including related indices, into strategic asset allocation.
          Concern about climate change continues to rise, with a strong majority
          viewing it as a material risk to long-term portfolio performance.
        </p>
        <p>
          What stands out in 2025 is the growing emphasis on financial outcomes.
          Improved risk-adjusted returns have emerged as the primary motivation
          for incorporating sustainability factors, followed closely by
          long-term risk mitigation. Fiduciary duty has gained significant
          importance compared to previous years, signaling a maturing view of
          ESG as a core investment responsibility rather than a values-led
          exercise. Delivering positive societal outcomes, while still relevant,
          now ranks lower than financial and risk considerations.
        </p>
        <p>
          In practice, asset owners favor pragmatic implementation. ESG
          integration and thematic investing remain the most widely used
          approaches, while active ownership and engagement are preferred over
          divestment for managing exposure to carbon-intensive assets. However,
          challenges persist. Concerns around greenwashing, inconsistent ESG
          data quality, and fragmented regulatory frameworks continue to slow
          wider adoption, underscoring the need for greater transparency and
          standardization across global markets.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            From a sustainability perspective, this shift will accelerate the
            integration of climate and ESG risks into core financial analysis,
            reshaping capital allocation globally. As performance becomes the
            primary driver, sustainability strategies are likely to scale
            faster, influence corporate behavior through active engagement, and
            strengthen market demand for credible data, clearer regulation, and
            measurable real-world impact.
          </p>
        </div>
      </div>
      <Subscribe />
    </>
  );
}

export default Newsletter_40;
